import React from "react";

import "./style.scss";

import {
    Box,
    Button,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import { SearchBarState } from "./models";

export class SearchBar extends React.Component<{}, SearchBarState> {

    constructor(props: any) {

        super(props);

        this.state = {
            openSearchBar: false,
            search: null,
        };
    }

    componentDidMount() {

        window.addEventListener("searchBar", () => {
            if (!this.state.search) {
                this.setState(() => ({ openSearchBar: false }));
            }
        });

        if (this.state.openSearchBar) {
            document.body.addEventListener("click", () => {
                this.setState(() => ({ openSearchBar: false }));
            });
        }
    }

    render() {

        return (
            <Box className="search-box">
                <Button 
                    className={`search-box-icon ${this.state.openSearchBar ? "active-icon" : ""}`}
                    onClick={() => this.setState({ openSearchBar: !this.state.openSearchBar })}
                >
                    <SearchIcon fontSize="small" />
                </Button>
                <input className={`search-box-input ${this.state.openSearchBar ? "active-input" : ""}`}
                    type="text"
                    placeholder="Cerca"
                    onChange={(e) => this.setState({ search: e.target.value })}>
                </input>
            </Box>
        );
    }
}